@if (subscriptionItems.length > 1) {
  <div class="grid-1">
    <app-subscription-selector
      (selectedSubscriptionChanged)="setProductsForSubscription($event);"/>
  </div>
}
@if (products.length < 1) {
  <app-not-found header="Geen bestelbare producten gevonden">
    <span>Neem contact op met onze klantenservice.</span>
    <app-button routerLink="/dashboard/customersupport" type="primary" ngProjectAs="[button]">Contact opnemen</app-button>
  </app-not-found>
} @else {
  <div class="container grid-desktop-2 grid-tablet-1 grid-mobile-1 full-height">
    <app-product-list (order)="order($event)" [products]="products"/>
  </div>
}
